import { atomFamily } from "recoil";
import { TableId } from "types/models";

export const dragAndDropEnabledAtom = atomFamily<boolean, TableId>({
    key: "table-dragAndDropEnabled",
    default: false,
});